<div mat-dialog-title class="mat-title">
  <span>Alert</span><span [mat-dialog-close]="false" class="close-dialog">&#10006;</span>
 
</div>
<mat-dialog-content>
  <div class="img-container">
    <img class="warning-img" src="../assets/Warning.svg" alt="">
  </div>
  
  <p class="warning-content">There are some unsaved changes. <br> Do you still want to proceed?</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="primary" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button color="primary" mat-raised-button [mat-dialog-close]="true">Proceed</button>
</mat-dialog-actions>